module.exports = __webpack_public_path__ + "static/img/pointLightUp.cfc5d06.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mapIndex/images/pointLightUp.png
// module id = de+S
// module chunks = 6